import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Landing from './Landing';
import DesignView from './DesignView';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/:id" element={<DesignView />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
